const Flickity = require('flickity');
export function carousel() {
  const carouselContainer = document.querySelectorAll('.js-carousel-container');
  if(carouselContainer) {
    for (let i = 0; i < carouselContainer.length; i++) {
      const _carouselContainer = carouselContainer[i];
      const carousel = _carouselContainer.querySelector('.js-carousel');
      const prev = _carouselContainer.querySelector('.js-carousel-prev');
      const next = _carouselContainer.querySelector('.js-carousel-next');
      const carouselCaption = _carouselContainer.querySelector('.js-carousel-caption');
      const carouselCount = _carouselContainer.querySelector('.js-carousel-current');

      const cellIframe = (index) => {
        const cells = _carouselContainer.querySelectorAll('.js-carousel-cell');
        if(cells){
          for (let i = 0; i < cells.length; i++) {
            const el = cells[i];
            if(el.classList.contains('is-iframe')) {
              if(i == index && el.dataset.code) {
                el.innerHTML = el.dataset.code;
              } else {
                el.innerHTML = '';
              }
            }
          }
        }
      }
      if(carousel) {
        const flkty = new Flickity(carousel, {
          cellSelector: '.js-carousel-cell',
          cellAlign: 'left',
          wrapAround: true,
          groupCells: true,
          setGallerySize: false,
          prevNextButtons: false,
          pageDots: false,
          pauseAutoPlayOnHover: false,
          on: {
            ready: () => {
              cellIframe(0);
            }
          }
        });
        if(prev){
          prev.addEventListener('click', (e) => {
            flkty.previous();
            e.preventDefault();
          });
        }
        if(next){
          next.addEventListener('click', (e) => {
            flkty.next();
            e.preventDefault();
          });
        }
        if(carouselCount) {
          flkty.on('change', (index) => {
            const current = _carouselContainer.querySelectorAll('.js-carousel-cell')[index];
            const caption = current.dataset.caption;
            if(caption) {
              carouselCaption.innerHTML = caption;
            } else {
              carouselCaption.innerHTML = '';
            }
            carouselCount.innerHTML = index+1;
          });
        }
        flkty.on('change', (index) => {
          cellIframe(index);
        })
      }
    }
  }
}